import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { BottomNav } from './BottomNav';

export function AppShell() {
    return (
        <div className="min-h-screen  h-screen bg-background pb-20"> {/* pb-20 for bottom nav space */}
            <TopBar />
            <main className="container max-w-md mx-auto p-4 h-full">
                <Outlet />
            </main>
            <BottomNav />
        </div>
    );
}
